function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M19.406 4.781a.592.592 0 01.438.25A.792.792 0 0120 5.5c0 2.625-.656 5.063-1.969 7.313a14.57 14.57 0 01-5.218 5.218C10.563 19.344 8.125 20 5.5 20a.792.792 0 01-.469-.156.593.593 0 01-.25-.438l-.75-3.25a.705.705 0 01.063-.5.673.673 0 01.375-.343l3.5-1.5a.793.793 0 01.468-.047c.167.03.303.12.407.265l1.531 1.875a10.985 10.985 0 003.266-2.281 11.48 11.48 0 002.265-3.25l-1.875-1.562a.748.748 0 01-.25-.391.78.78 0 01.031-.484l1.5-3.5a.69.69 0 01.344-.344.705.705 0 01.5-.063l3.25.75z"
});

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgPhone;